"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMS = void 0;
var cms_conf_1 = require("./cms.conf");
var networker_1 = require("@idp/networker");
var cmsContents = {};
if (cms_conf_1.CmsENV.aem.staticSiteMode) {
    try {
        cmsContents = require("../../../../stub/content");
    }
    catch (ex) {
        // console.log(ex);
    }
}
var CMS = /** @class */ (function () {
    function CMS(stateManager) {
        this.common = {};
        this.content = {};
        this.cmsCache = {};
        this.cmsCommon = {};
        this.cmsContent = {};
        this.orchestrationFlag = false;
        this.cmsCallFailureCounter = 0;
        this.csrfApi = '/msapi/id';
        this.CSRF_TOKEN = 'csrf-token';
        this.headers = [
            {
                name: 'Accept-Language',
                value: 'application/json',
            },
            {
                name: 'Content-Type',
                value: 'application/json',
            },
            {
                name: 'X-ATT-Transaction-Id',
                value: '234',
            },
        ];
        // this.init();
        this.stateManager = stateManager; // StateProvider.getStateManagerInstance('appShell');
    }
    /**
     * Used to fetch cms data
     * @param component used to derive component.props.loaction i.e. available in case of child of routable component
     * @param cmsPageName page name used as key to store cms content in cache
     * @param contentUrl cms content url to override computed url from route path
     * @param orchestrationFlag this flag will enable for disable orchestraion layer call.
     * @param forceUpdate this flag will avoid local data and forcefully call ajax request for subsequent request
     */
    CMS.route = function (component, cmsPageName, contentUrl, orchestrationFlag, stateManager, forceUpdate) {
        return CMS.getInstance(stateManager)._route(component, cmsPageName, contentUrl, orchestrationFlag, forceUpdate);
    };
    /**
     * Retuns cms data from cache
     * @param config contains initial values new Object of *.cms.ts
     * @param selectorName page name
     */
    CMS.get = function (config, selectorName) {
        return CMS.getInstance()._get(config, selectorName);
    };
    CMS.getInstance = function (stateManager) {
        if (!CMS.cms) {
            CMS.cms = new CMS(stateManager);
        }
        if (CMS.cms && !CMS.cms.stateManager && stateManager) {
            CMS.cms.stateManager = stateManager;
        }
        return CMS.cms;
    };
    CMS.prototype._route = function (component, cmsPageNameObjectName, contentUrl, orchestrationFlag, forceUpdate) {
        var _this = this;
        var promiseRouteObject = new Promise(function (resolve, reject) {
            var cmsFeedName = null;
            if (typeof cmsPageNameObjectName === 'object') {
                cmsFeedName = cmsPageNameObjectName.pageName || null;
            }
            else if (typeof cmsPageNameObjectName === 'string') {
                cmsFeedName = cmsPageNameObjectName;
            }
            if (!forceUpdate && _this.content && cmsFeedName && _this.content[cmsFeedName]) {
                resolve(_this.content[cmsFeedName]);
            }
            else {
                var isFeedAemUrl = false;
                var orchFlag = orchestrationFlag ? true : false; // Orchestraion flag for the orchestration call
                var contentURL = contentUrl ? contentUrl : '';
                var pageName_1 = cmsPageNameObjectName ? cmsPageNameObjectName : component.props.location.pathname
                    .replace(/\//gi, ' ')
                    .trim()
                    .replace(/( \w)/g, function ($1) {
                    return $1[1].toUpperCase();
                });
                _this.content = _this.content || {};
                _this.cmsContent = cmsContents ? cmsContents[pageName_1] : undefined;
                if ((typeof orchFlag === 'undefined') || !orchFlag) {
                    isFeedAemUrl = true;
                }
                if (typeof location !== 'undefined') {
                    var fetchUrl_1 = '';
                    if (typeof contentUrl === 'string' &&
                        (contentUrl.toUpperCase().indexOf('HTTP://') === 0 ||
                            contentUrl.toUpperCase().indexOf('HTTPS://') === 0)) {
                        fetchUrl_1 = contentUrl;
                    }
                    else {
                        fetchUrl_1 = isFeedAemUrl ?
                            location.protocol + '//' + location.host + contentUrl :
                            _this.getUrl(contentURL);
                    }
                    // LOGIC added for Orchestraion and Personalization to fetch AEM data
                    // FETCH URL appended with parameters of the object that is passed as
                    // 2nd param in the CMS route call.
                    if (typeof pageName_1 === 'object') {
                        var queryParamStarted_1 = false;
                        Object.keys(pageName_1).forEach(function (key) {
                            if (!queryParamStarted_1) {
                                fetchUrl_1 = fetchUrl_1 + '?' + key + '=' + pageName_1[key];
                                queryParamStarted_1 = true;
                            }
                            else {
                                fetchUrl_1 = fetchUrl_1 + '&' + key + '=' + pageName_1[key];
                            }
                            // console.log(fetchUrl);
                        });
                    }
                    _this.fetch(fetchUrl_1)
                        .then(function (unfilteredContent) {
                        // Logic for master key removal from the fetched CMS feed file
                        function removeJSONString(jsonobj) {
                            var newMasterObject = jsonobj;
                            var obj = {};
                            if (typeof newMasterObject === 'string') {
                                obj = JSON.parse(newMasterObject);
                            }
                            else {
                                obj = newMasterObject;
                            }
                            if (typeof obj !== 'boolean' &&
                                typeof obj !== 'number' && typeof obj !== 'string') {
                                var keys = Object.keys(obj);
                                keys.map(function (key, val) {
                                    if (obj[key].master) {
                                        Object.assign(obj[key], obj[key].master);
                                        delete obj[key].master;
                                        removeJSONString(obj[key]);
                                    }
                                    else {
                                        if (typeof obj[key] !== 'string') {
                                            // console.log(typeof obj[key]);
                                            removeJSONString(obj[key]);
                                        }
                                    }
                                });
                            }
                            return obj;
                        }
                        // Logic for <empty/> tag removal for the keys that expect the empty string
                        function fixEmpty(object) {
                            var newObject;
                            if (object) {
                                if (object instanceof Array) {
                                    newObject = __spreadArrays(object);
                                }
                                else if (typeof object !== 'boolean') {
                                    newObject = __assign({}, object);
                                }
                                else {
                                    return object;
                                }
                                for (var key in object) {
                                    if (object[key]) {
                                        if (object[key] === "<empty/>") {
                                            newObject[key] = "";
                                        }
                                        else if (typeof object[key] !== "string") {
                                            newObject[key] = fixEmpty(object[key]);
                                        }
                                    }
                                }
                            }
                            return newObject;
                        }
                        // Removing master key from content json
                        var cmsfeedwithEmpty = removeJSONString(unfilteredContent);
                        // Removing Empty tag for the case of empty string key render
                        var cmsfeed = fixEmpty(cmsfeedwithEmpty);
                        if (_this.content) {
                            // Logic for appending the data to the existing cms object.
                            // const jsonKey = Object.keys(cmsfeed['idp-cms-feed'])[0];
                            // this.content[jsonKey] = cmsfeed['idp-cms-feed'][jsonKey];
                            Object.keys(cmsfeed['idp-cms-feed']).forEach(function (key) {
                                _this.content[key] = cmsfeed['idp-cms-feed'][key];
                            });
                            resolve(cmsfeed['idp-cms-feed']);
                            // console.log('CMS OBJECT ---------- ', this.content)
                        }
                        else {
                            _this.content = cmsfeed['idp-cms-feed'];
                            resolve(cmsfeed['idp-cms-feed']);
                        }
                        component.forceUpdate();
                    })
                        .catch(function (err) {
                        // this.cmsCallFailureCounter++;
                        // if (this.cmsCallFailureCounter > 1) {
                        // reject('CMS ROUTE CALL FAILED !!! --- ' + err);
                        // return 'Error in route call, couldn`t get the data, 2nd call also failed';
                        // }
                        // if (orchestrationFlag) {
                        //     this.orchestrationFlag = false;
                        //     const urlParams = fetchUrl.split('/');
                        //     if (urlParams) {
                        //         urlParams[1] += '/prod';
                        //     }
                        //     fetchUrl = urlParams.join('/');
                        //     this.fetch(fetchUrl + CmsENV.aem.extension);
                        // }
                        /* Code updated as per Renny requirement - Start */
                        _this.cmsCallFailureCounter++;
                        if (_this.cmsCallFailureCounter > 1) {
                            reject('CMS ROUTE CALL FAILED !!! --- ' + err);
                            return 'Error in route call, couldn`t get the data, 2nd call also failed';
                        }
                        if (orchestrationFlag) {
                            _this.orchestrationFlag = false;
                            // const urlParams = fetchUrl.split('/');
                            var urlParams = fetchUrl_1.split(cms_conf_1.CmsENV.orchestration.path);
                            var salesUrlParam = urlParams[1].split('sales/');
                            if (urlParams) {
                                // urlParams[1] += '/prod';
                                fetchUrl_1 = urlParams[0] + salesUrlParam[0] + 'sales/prod/'
                                    + salesUrlParam[1];
                            }
                            // fetchUrl = urlParams.join('/');
                            _this.fetch(fetchUrl_1 + cms_conf_1.CmsENV.aem.extension);
                        }
                        else {
                            reject('CMS ROUTE CALL FAILED !!! --- ' + err);
                            return 'Error in route call, couldn`t get the data, 2nd call also failed';
                        }
                        /* Code updated as per Renny requirement - End */
                    });
                }
            }
        });
        return promiseRouteObject;
    };
    CMS.prototype._get = function (config, selectorName) {
        // let common: any;
        var content;
        // Common data mapping
        // if (this.cmsCommon && this.cmsCommon.common) {
        //     common = this.cmsCommon.common.state;
        // }
        // if (this.common && this.common.common) {
        //     common = this.common.common.state;
        // }
        // CMS data mapping
        if (config) {
            content = this.parseDefaultValues(config);
        }
        if (this.cmsContent && this.cmsContent[selectorName]) {
            content = this.cmsContent[selectorName].state;
        }
        if (this.content && this.content && this.content[selectorName]) {
            if (config.cmstransformer) {
                content = config.cmstransformer(this.content[selectorName].contentFragments);
            }
            else {
                content = this.content[selectorName].contentFragments;
            }
        }
        return {
            // common,
            content: content,
        };
    };
    // private async init() {
    //     this.cmsCommon = cmsContents ? cmsContents[CmsENV.aem.commonPageName] : undefined;
    //     this.fetch(this.getUrl(CmsENV.aem.commonPageName))
    //         .then((data) => {
    //             this.common = data;
    //         });
    // }
    CMS.prototype.getUrl = function (contentUrl) {
        var host = '';
        if (typeof location !== 'undefined') {
            host = location.protocol + '//' + location.host;
        }
        return "" + host + cms_conf_1.CmsENV.orchestration.path + contentUrl;
    };
    CMS.prototype.fetch = function (url) {
        var _this = this;
        if (cms_conf_1.CmsENV.aem.runtimeMode) {
            return new Promise(function (resolve, reject) {
                var response;
                // let fetchResponse: any;
                if (_this.cmsCache[url]) {
                    response = _this.cmsCache[url];
                    resolve(response);
                }
                else {
                    _this.fetchData(url)
                        .catch(function (err) {
                        // console.log(err);
                        reject(err);
                    })
                        // .then((resp: any) => {
                        //     if (resp.ok) {
                        //         return resp.text();
                        //     }
                        // })
                        .then(function (fetchResponse) {
                        if (fetchResponse) {
                            try {
                                response = fetchResponse; // JSON.parse(fetchResponse);
                                _this.cmsCache[url] = fetchResponse;
                                resolve(response);
                            }
                            catch (e) {
                                reject('json parse exception for ' + url + e);
                            }
                        }
                    });
                }
                // return response;
            });
        }
        else {
            return Promise.reject('Static page generation mode');
        }
    };
    CMS.prototype.fetchData = function (url) {
        var _this = this;
        var stateCsrfToken = this.getCsrfToken();
        var queryParam = location.href.split('?')[1];
        if (queryParam) {
            var parmaArry = queryParam.split('&');
            for (var _i = 0, parmaArry_1 = parmaArry; _i < parmaArry_1.length; _i++) {
                var checkuuid = parmaArry_1[_i];
                if ((/uuid/i).test(checkuuid)) {
                    var uuidArry = checkuuid.split('=');
                    var uuidval = uuidArry[1];
                    this.csrfApi = this.csrfApi + '?uuid=' + uuidval;
                }
            }
        }
        if (!this.stateManager || (stateCsrfToken && stateCsrfToken.value)) {
            return this.augmentedFetchData(url);
        }
        else {
            var networker = new networker_1.Networker();
            return networker.get(this.csrfApi, {
                headers: this.getInitialHeaders(),
            })
                .then(this.rejectHTTPErrors)
                .then(function (res) {
                var token = { value: res.headers.get('X-CSRF-TOKEN') };
                var sessionId = { value: res.headers.get('sid') };
                if (sessionId && sessionId.value && _this.stateManager !== null && _this.stateManager !== undefined) {
                    _this.stateManager.set('sid', sessionId);
                }
                if (token.value !== null) {
                    if (_this.stateManager !== null && _this.stateManager !== undefined) {
                        _this.stateManager.set(_this.CSRF_TOKEN, token);
                    }
                    /* New Session Edit - Starts */
                    // Moved the code to MainView.container
                    /* New Session Edit - Ends */
                    return _this.augmentedFetchData(url);
                }
                else {
                    return Promise.reject(res);
                }
            });
        }
    };
    CMS.prototype.augmentedFetchData = function (url) {
        var networker = new networker_1.Networker();
        return networker.get(url, this.fetchCRT())
            .then(this.rejectHTTPErrors)
            .then(function (res) { return res.json(); });
    };
    CMS.prototype.fetchCRT = function () {
        var options = {};
        var stateCsrfToken = this.getCsrfToken();
        var customHeaders = new Headers();
        if (stateCsrfToken && stateCsrfToken.value) {
            customHeaders.set('X-CSRF-TOKEN', stateCsrfToken.value);
            options = {
                headers: customHeaders,
            };
        }
        return options;
    };
    CMS.prototype.getInitialHeaders = function () {
        var defaultHeaders = new Headers();
        this.headers.forEach(function (header) {
            defaultHeaders.append(header.name, header.value);
        });
        return defaultHeaders;
    };
    CMS.prototype.rejectHTTPErrors = function (res) {
        if (res.status === 401) {
            return Promise.reject(res);
        }
        else if (res.status > 401) {
            return Promise.reject(res);
        }
        else {
            return Promise.resolve(res);
        }
    };
    CMS.prototype.getCsrfToken = function () {
        return this.stateManager !== null && this.stateManager !== undefined ?
            this.stateManager.get('appShell', this.CSRF_TOKEN) : { value: '' };
    };
    CMS.prototype.parseDefaultValues = function (config) {
        return config;
    };
    return CMS;
}());
exports.CMS = CMS;
//# sourceMappingURL=cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/cms-integration/cms.js
// module id = 1417
// module chunks = 8